import {
  IGetUsersResponse,
  IPostNewUserResponse,
} from 'v2/resources/types/users';

export const DEFAULT_RESPONSE_GET_USERS: Array<IGetUsersResponse> = [
  {
    id: '',
    name: '',
    email: '',
    cellphone: '',
    cpfCnpj: '',
    active: false,
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
    function: '',
    nature: 'pf',
    last_domain: '',
    lastLogin: '',
    firstAccess: false,
    permissions: {
      performance: [],
      production: [],
      reports: [],
      purchases: [],
      finance: [],
      commercial: [],
      employees: [],
    },
  },
];

export const DEFAULT_RESPONSE_POST_NEW_USER: IPostNewUserResponse = {
  message: '',
};
